import React from 'react';
import './Footer.css';
import { FaWindows, FaApple, FaAndroid, FaLinux, FaTelegramPlane, FaTwitter, FaHeadset } from "react-icons/fa";
import { BsPhone } from "react-icons/bs";
import { color } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = ({ id, ...props }) => {
  const currentYear = 2026;

  return (
    <footer className="footer" id={id} {...props}>
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">RED BUTTON</Link>
            <p className="footer-tagline">Интернет без границ</p>
          </div>

          <div className="footer-nav">
            <div className="nav-column">
              <h3>Продукт</h3>
              <ul>
                <li><a onClick={() => {
                  window.location.href = '/#/';
                  setTimeout(() => {
                    document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' });
                  }, 200);
                }}>Тарифы</a></li>
                <li><a onClick={() => {
                        document.getElementById('next').scrollIntoView({
                          behavior: 'smooth'
                        });
                      }}>
                        Возможности</a></li>
                <li><a href="/monitoring" target='_blank'>Серверы</a></li>
              </ul>
            </div>

            <div className="nav-column">
              <h3>Скачать</h3>
              <ul className="download-list">
                <li>
                  <Link to="/setup/windows" className="download-link">
                    <FaWindows />
                    Windows
                  </Link>
                </li>
                <li>
                  <Link to="/setup/ios" className="download-link">
                  <FaApple />
                                  macOS
                                </Link>
                </li>
                <li>
  
                  <Link to="/setup/ios" className="download-link">
                  <BsPhone />
                                  iOS
                                </Link>
                </li>
                <li>
                  <Link to="/setup/android" className="download-link">
                    <FaAndroid />
                    Android
                  </Link>
                </li>
                <li>
                  <Link to="/setup/linux" className="download-link">
                    <FaLinux />
                    Linux
                  </Link>
                </li>
              </ul>
            </div>

            <div className="nav-column">
              <h3>Компания</h3>
              <ul>
                <li><a href="#about">О нас</a></li>
                <li><a href="#privacy">Приватность</a></li>
                <li><a href="#terms">Условия</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <span>© {currentYear} RED BUTTON</span>
            {/*<span className="jurisdiction">ИП Козлов Роман Валентинович</span>*/}
            {/*<span className="jurisdiction">ИНН: 254300827766</span>*/}
            {/*<span className="jurisdiction">ОГРНИП: 324253600051345 </span>*/}<br/>
            <a href="oferta.html" target="_blanc" className="jurisdition-link">Договор оферты</a>
            <a href="policy.html" target="_blanc" className="jurisdition-link">Политика конфиденциальности</a><br/>
            <span className="jurisdiction" style={{color: "white !important"}}>Email support: info@redvpn.online</span>
            <span className="jurisdiction" style={{color: "white !important"}}>Telegram support: t.me/arden_support</span>
          </div>
          
          <div className="footer-social">
            <a href="https://t.me/redbutton_vpn_bot" target="_blank" className="social-link">
              <FaTelegramPlane />
              Telegram
            </a>
            {/*<a href="#" className="social-link">
              <FaTwitter />
              Twitter
            </a>*/}
            <a href="https://t.me/arden_support" target="_blank" className="social-link">
              <FaHeadset />
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;